import { render, staticRenderFns } from "./VideoPanel.vue?vue&type=template&id=39d9edfa&scoped=true&"
import script from "./VideoPanel.vue?vue&type=script&lang=js&"
export * from "./VideoPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoPanel.vue?vue&type=style&index=0&id=39d9edfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9edfa",
  null
  
)

export default component.exports